/* eslint-disable */
import * as Types from '../../graphql/types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;

export const UserDocument = gql`
    query User {
  user {
    domains {
      id
      title
      userAccesses {
        accessType
      }
      firstPage {
        image
      }
      folders {
        id
        title
        allDescendants {
          id
          title
        }
        userAccesses {
          id
        }
        domain {
          id
          title
        }
      }
      countDomainPages
      countDomainFolders
    }
    folders {
      id
      title
    }
    id
    email
    firstName
    lastName
    admin
    activePremium
    userPremium {
      userPremiumEndDate
      trialActive
      daysUntilEnd
    }
    canPublish
    phone
    country {
      id
      title
    }
    countSharedPagesFoldersDomains
    countMyPages
    countPublishPages
    originalUserIfSwitched {
      id
    }
    userCompany {
      id
      companyEmail
      companyAddress
      companyName
      companyWebsite
      companyTaxVat
    }
    countSharedPagesToMe
    countSharedFoldersToMe
    countSharedDomainsToMe
  }
}
    `;

/**
 * __useUserQuery__
 *
 * To run a query within a React component, call `useUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useUserQuery(baseOptions?: Apollo.QueryHookOptions<UserQuery, UserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<UserQuery, UserQueryVariables>(UserDocument, options);
      }
export function useUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
// @ts-ignore
export function useUserSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>): Apollo.UseSuspenseQueryResult<UserQuery | undefined, UserQueryVariables>;
export function useUserSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<UserQuery, UserQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<UserQuery, UserQueryVariables>(UserDocument, options);
        }
export type UserQueryHookResult = ReturnType<typeof useUserQuery>;
export type UserLazyQueryHookResult = ReturnType<typeof useUserLazyQuery>;
export type UserSuspenseQueryHookResult = ReturnType<typeof useUserSuspenseQuery>;
export type UserQueryResult = Apollo.QueryResult<UserQuery, UserQueryVariables>;
export const UserBlockDocument = gql`
    mutation userBlock($status: Boolean!, $userId: Int!, $comment: String!) {
  userBlock(status: $status, userId: $userId, comment: $comment) {
    id
    email
  }
}
    `;
export type UserBlockMutationFn = Apollo.MutationFunction<UserBlockMutation, UserBlockMutationVariables>;

/**
 * __useUserBlockMutation__
 *
 * To run a mutation, you first call `useUserBlockMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUserBlockMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [userBlockMutation, { data, loading, error }] = useUserBlockMutation({
 *   variables: {
 *      status: // value for 'status'
 *      userId: // value for 'userId'
 *      comment: // value for 'comment'
 *   },
 * });
 */
export function useUserBlockMutation(baseOptions?: Apollo.MutationHookOptions<UserBlockMutation, UserBlockMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UserBlockMutation, UserBlockMutationVariables>(UserBlockDocument, options);
      }
export type UserBlockMutationHookResult = ReturnType<typeof useUserBlockMutation>;
export type UserBlockMutationResult = Apollo.MutationResult<UserBlockMutation>;
export type UserBlockMutationOptions = Apollo.BaseMutationOptions<UserBlockMutation, UserBlockMutationVariables>;
export type UserQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserQuery = { __typename?: 'Query', user?: { __typename?: 'GraphUser', id?: number | null, email?: string | null, firstName?: string | null, lastName?: string | null, admin: boolean, activePremium: boolean, canPublish: boolean, phone?: string | null, countSharedPagesFoldersDomains: number, countMyPages: number, countPublishPages: number, countSharedPagesToMe: number, countSharedFoldersToMe: number, countSharedDomainsToMe: number, domains: Array<{ __typename?: 'GraphDomain', id?: number | null, title?: string | null, countDomainPages: number, countDomainFolders: number, userAccesses: Array<{ __typename?: 'UserAccess', accessType?: number | null }>, firstPage?: { __typename?: 'GraphPage', image?: string | null } | null, folders: Array<{ __typename?: 'GraphFolder', id: number, title: string, allDescendants: Array<{ __typename?: 'GraphFolder', id: number, title: string }>, userAccesses: Array<{ __typename?: 'UserAccess', id?: number | null }>, domain?: { __typename?: 'GraphDomain', id?: number | null, title?: string | null } | null }> }>, folders: Array<{ __typename?: 'GraphFolder', id: number, title: string }>, userPremium?: { __typename?: 'GraphUserPremium', userPremiumEndDate?: any | null, trialActive: boolean, daysUntilEnd?: number | null } | null, country?: { __typename?: 'GraphCountry', id?: number | null, title: string } | null, originalUserIfSwitched?: { __typename?: 'GraphUser', id?: number | null } | null, userCompany?: { __typename?: 'GraphUserCompany', id?: number | null, companyEmail?: string | null, companyAddress?: string | null, companyName?: string | null, companyWebsite?: string | null, companyTaxVat?: string | null } | null } | null };

export type UserBlockMutationVariables = Types.Exact<{
  status: Types.Scalars['Boolean']['input'];
  userId: Types.Scalars['Int']['input'];
  comment: Types.Scalars['String']['input'];
}>;


export type UserBlockMutation = { __typename?: 'Mutation', userBlock: { __typename?: 'GraphUser', id?: number | null, email?: string | null } };
